import { heightWithLabel, minHeight } from './constants';
import { Loader, LoaderInline } from './rich-text-loader';
import type { LoaderProps } from './rich-text-loader';

export function RichTextLoader(props: LoaderProps) {
  const { withLabel = false, inline = false, ...restProps } = props;

  const height = withLabel ? heightWithLabel : minHeight;

  return inline ? (
    <LoaderInline withLabel={withLabel} height={height} {...restProps} />
  ) : (
    <Loader withLabel={withLabel} height={height} inline={inline} {...restProps} />
  );
}
